import { Box, ToggleButtonGroup, Typography, styled } from '@mui/material'
import { MUIThemeColors } from 'src/mui-theme'
import { GetRGBA, getThemeColor } from 'src/utils'

export const SectionLabel = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: getThemeColor(theme, MUIThemeColors.secondaryDark),
}))

// Segmented choice: outlined group, the chosen option tinted with the primary colour like the app's toggle buttons.
export const Segmented = styled(ToggleButtonGroup)(({ theme }) => ({
  borderRadius: 8,
  backgroundColor: getThemeColor(theme, MUIThemeColors.white),
  '& .MuiToggleButton-root': {
    border: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
    padding: theme.spacing(0.75, 1.75),
    fontSize: 13,
    fontWeight: 600,
    textTransform: 'uppercase',
    color: getThemeColor(theme, MUIThemeColors.secondaryDark),
  },
  '& .MuiToggleButton-root.Mui-selected, & .MuiToggleButton-root.Mui-selected:hover': {
    backgroundColor: GetRGBA(getThemeColor(theme, MUIThemeColors.primaryMain), 0.08),
    color: getThemeColor(theme, MUIThemeColors.primaryMain),
  },
}))

export const StatTile = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  gap: 6,
  padding: theme.spacing(1, 1.5),
  borderRadius: 8,
  backgroundColor: getThemeColor(theme, MUIThemeColors.backgroundMain),
  '& b': { fontSize: 18, color: getThemeColor(theme, MUIThemeColors.primaryMain) },
  '& span': { fontSize: 12, color: getThemeColor(theme, MUIThemeColors.secondaryDark) },
}))

// A section of a side panel: a bordered card with a header row (label left, count or note right) over its content.
export const PanelCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(1.25, 1.5),
  borderRadius: 8,
  border: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
  backgroundColor: getThemeColor(theme, MUIThemeColors.white),
}))

export const PanelHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  paddingBottom: theme.spacing(0.75),
  borderBottom: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
}))

// A row of a side-panel list: content on the left, a control or note on the right.
export const ListRow = styled(Box, { shouldForwardProp: prop => prop !== 'muted' })<{ muted?: boolean }>(
  ({ theme, muted }) => ({
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) auto',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(0.75, 0),
    opacity: muted ? 0.6 : 1,
    borderBottom: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
    '&:last-child': { borderBottom: 'none', paddingBottom: 0 },
  }),
)
